var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.480469,
    width: 32.4804,
    height: 32.4804,
    rx: 10,
    fill: "#FF704B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_457_217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2284 11.0015C26.1197 10.5674 25.8984 10.1696 25.5868 9.84834C25.2752 9.5271 24.8843 9.29377 24.4537 9.17194C22.8802 8.78772 16.5864 8.78772 16.5864 8.78772C16.5864 8.78772 10.2926 8.78772 8.71911 9.20853C8.28847 9.33036 7.8976 9.56369 7.58599 9.88494C7.27438 10.2062 7.05307 10.604 6.9444 11.0381C6.65644 12.635 6.51558 14.2548 6.52359 15.8774C6.51333 17.5122 6.6542 19.1444 6.9444 20.7533C7.0642 21.174 7.29048 21.5566 7.60136 21.8643C7.91224 22.172 8.29723 22.3943 8.71911 22.5097C10.2926 22.9305 16.5864 22.9305 16.5864 22.9305C16.5864 22.9305 22.8802 22.9305 24.4537 22.5097C24.8843 22.3879 25.2752 22.1545 25.5868 21.8333C25.8984 21.5121 26.1197 21.1143 26.2284 20.6801C26.5141 19.0953 26.655 17.4878 26.6492 15.8774C26.6594 14.2426 26.5186 12.6104 26.2284 11.0015Z",
    stroke: "white",
    strokeWidth: 1.01217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5281 18.8688L19.7882 15.8774L14.5281 12.886V18.8688Z",
    stroke: "white",
    strokeWidth: 1.01217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_457_217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9552,
    height: 21.9552,
    fill: "white",
    transform: "translate(5.60876 5.12848)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.017ffa122cc21435b9a23bef9c7fa740.svg";
export { ForwardRef as ReactComponent };